import '../../styles/templates/cart.scss';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import pTry from 'p-try';
import { isProduction, isLocal } from '../utils/environment';
import ErrorBoundary from '../utils/react/ErrorBoundary';
//@ts-expect-error
import { cookiesEnabled } from '@shopify/theme-cart';
import CartPage from '../sections/header/Cart/components/CartPage';
import { isCartApiCheckoutButtonEnabled } from '../utils/cart';
import { contentLoaded } from '../utils/document-promises';
import { checkIfInVariation } from '../utils/optimizely';

const shouldShowFixedCheckoutButton = checkIfInVariation({
  variationId: '5960005099192320',
  experimentId: '6697435414659072',
});

console.log({shouldShowFixedCheckoutButton});


const runCartStartupScripts = async () => {
  pTry(() => {
    if (isCartApiCheckoutButtonEnabled) {
      import('src/scripts/sections/header/Cart/components/CartCheckoutButton').then((module) => {
        module.renderCartCheckoutButton();
      });
    }
  });
  await contentLoaded;
  if (shouldShowFixedCheckoutButton)
    console.log("SHOULD SHOW STICKY");
    
    import('../sections/header/Cart/components/StickyCheckoutButton').then((module) =>
      module.renderStickyCheckoutButton()
    );
};

// Apply a specific class to the html element for browser support of cookies.
if (!cookiesEnabled()) {
  document.documentElement.classList.add('supports-no-cookies');
}

// Render CartPage React Component(s)
const onError = () => {
  if (isProduction) {
    // ? [REVISIT][PROD] error handling?
  }
};
const render = (Component: () => JSX.Element, mountNode: HTMLElement = document.createElement('div')) => {
  return ReactDOM.render(
    <StrictMode>
      <ErrorBoundary className="centered-message" key={(!isLocal || new Date()).toString()} onError={onError}>
        <Component />
      </ErrorBoundary>
    </StrictMode>,
    mountNode
  );
};
render(CartPage);
runCartStartupScripts();
